import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { Toast } from "vant";
import { doPasswordLogin } from "@/api/im";
import { usePiniaState } from "@/store/userPinia";
import { useRouter } from "vue-router";
import Platform from "@/config/platform";
import { md5, YMPush } from "@/uitls/uitls";
// import {ApiNetWork} from '@/network/apiNet/apiNet'
import { useI18n } from 'vue-i18n'
import { serverConfigPiniaState } from "@/store/serverConfig";

export default /*#__PURE__*/_defineComponent({
  name: 'PasswordLogin',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "42116dd1-btnTextColor": (btnTextColor.value),
  "42116dd1-btnColor": (btnColor.value)
}))

const { t } = useI18n()
const router = useRouter();
const piniaStore = usePiniaState();
const { loginSuccess } = piniaStore;

const configStore = serverConfigPiniaState();
const { getConfig } = configStore;


const userName = ref("");
const password = ref("");
const checked = ref(false);
let loginimg = require(`@/assets/${process.env.VUE_APP_NAME}/login_bg.png`);

onMounted(() => {
  YMPush('MAIN', 'LoginPage')
})

const successLogin = async () => {
  const toast = Toast.loading({
    duration: 0,
    forbidClick: true,
    message: t('me.loginsuccback'),
  });

  let second = 3;
  const timer = setInterval(() => {
    second--;
    if (second) {
      toast.message = t('me.loginsucc') + `${second} ` + t('me.threeback')
    } else {
      clearInterval(timer);
      Toast.clear();
      getConfig(false)
      router.replace("/");
    }
  }, 1000);

}
const doLogin = async () => {
  if (!checked.value) {
    return Toast(t('me.tyfwxy'));
  }
  if (userName.value == "") {
    return Toast.fail(t('me.inputname'));
  }
  if (password.value == "") {
    return Toast.fail(t('me.qsrmm'));
  }
  //去登录了
  const pss = md5(password.value);
  const res: any = await doPasswordLogin({
    uno: userName.value,
    loginpasswd: pss,
  });
  if (res.ret == 0) {
    // window.$Socket.ws = null;
    loginSuccess(res, true);
    successLogin()
  } else {
    return Toast.fail(res.msg);
  }
};

const backRouter = () => {
  router.back();
};
const btnColor = ref('#ECECEC')
const btnTextColor = ref('#898989')
const checkText = () => {
  if (userName.value !== "" && password.value !== "") {
    btnColor.value = '#0D0D0D'
    btnTextColor.value = "#fff"

  }
}
const xyData = ref("");

const getXy = () => {
  const appName = process.env.VUE_APP_NAME as string;
  switch (appName) {
    case "f7":
      xyData.value = Platform.address + "download/serviceAgreement.html";
      break;
    case "btv":
      xyData.value = Platform.address + "download/serviceAgreement_b.html";
      break;
    case "93":
      xyData.value = Platform.address + "download/serviceAgreement_tg.html";
      break;
    case "kw":
      xyData.value = Platform.address + "download/serviceAgreement_kw.html";
      break;
    case "r8":
      xyData.value = Platform.address + "download/serviceAgreement_h8.html";
      break;
    case "tq":
      xyData.value = Platform.address + "download/serviceAgreement_tq.html";
      break;
    case "wq":
      xyData.value = Platform.address + "download/serviceAgreement_wq.html";
      break;
    case "th":
      xyData.value = Platform.address + "download/serviceAgreement_th.html";
      break;

    default:
      xyData.value = Platform.address + "download/serviceAgreement.html";
      break;
  }
};

const __returned__ = { t, router, piniaStore, loginSuccess, configStore, getConfig, userName, password, checked, loginimg, successLogin, doLogin, backRouter, btnColor, btnTextColor, checkText, xyData, getXy }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})